import { forIn, merge } from 'lodash';
import type { IKeyValueMap } from './KeyValueMap.interface';

export default class KeyValueMap implements IKeyValueMap {
  #wm: Map;

  clear() {
    this.#wm = new Map();
  }

  delete(key?: String) {
    if (!key) {
      return null;
    }
    return this.#wm.delete(key);
  }

  get(key?: String) {
    if (!key) {
      return this.#wm.get('available') || this.#wm.get('default');
    }
    return this.#wm.get(key);
  }

  has(key?: String) {
    if (!key) {
      return false;
    }
    return this.#wm.has(key);
  }

  set(key?: String, value: any) {
    if (!key) {
      return null;
    }
    this.#wm.set(key, value);
    return this;
  }

  update(key?: String, value: any) {
    if (!key) {
      return null;
    }
    this.set(key, merge({}, this.get(key), value));
  }

  /**
   * Constructor
   * @param {Object} data
   */
  constructor(data?: Object) {
    this.#wm = new Map();
    forIn(data, (value, key) => {
      this.set(key, value);
    });
  }
}
